webpackJsonp([253224235265825],{

/***/ 1005:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPlacesAutocomplete = __webpack_require__(63);
	
	var _reactPlacesAutocomplete2 = _interopRequireDefault(_reactPlacesAutocomplete);
	
	var _bookNowFormConstants = __webpack_require__(31);
	
	var _bookNowFormConstants2 = _interopRequireDefault(_bookNowFormConstants);
	
	var _googlePlacesConstants = __webpack_require__(175);
	
	var _FormValidations = __webpack_require__(42);
	
	var _styledComponents = __webpack_require__(379);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author: Vamsi Tallam
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * */
	
	var LocationSearchInput = function (_React$Component) {
	  _inherits(LocationSearchInput, _React$Component);
	
	  function LocationSearchInput(props) {
	    _classCallCheck(this, LocationSearchInput);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.storeInputRef = function (ref) {
	      _this.inputRef = ref;
	    };
	
	    _this.storeAutocompleteRef = function (ref) {
	      _this.autoCompleteRef = ref;
	    };
	
	    _this.validate = function () {
	      return _this.inputRef.validate();
	    };
	
	    _this.handleChange = function (selected) {
	      var handleChange = _this.props.handleChange;
	
	      _this.setState({ address: selected });
	      handleChange(selected);
	    };
	
	    _this.handleSelect = function (selected) {
	      _this.setState({ address: selected });
	      _this.props.onBlur(selected);
	    };
	
	    _this.handleError = function (status, clearSuggestions) {
	      // eslint-disable-line no-console
	      _this.setState({}, function () {
	        clearSuggestions();
	      });
	      _this.props.handleError();
	    };
	
	    _this.clearValues = function () {
	      _this.inputRef.state.value = '';
	      _this.setState({
	        address: ''
	      });
	    };
	
	    _this.state = {
	      address: props.defaultValue || ''
	    };
	    return _this;
	  }
	
	  LocationSearchInput.prototype.render = function render() {
	    var _this2 = this;
	
	    var address = this.state.address;
	    var _props = this.props,
	        cityPlaceHolderText = _props.cityPlaceHolderText,
	        inputType = _props.inputType,
	        required = _props.required,
	        suggestionsContainerWidth = _props.suggestionsContainerWidth,
	        searchOptions = _props.searchOptions,
	        defaultValue = _props.defaultValue;
	
	    var value = address.split(',')[0];
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactPlacesAutocomplete2.default,
	        {
	          onChange: this.handleChange,
	          value: value,
	          onSelect: this.handleSelect,
	          onError: this.handleError,
	          searchOptions: searchOptions,
	          ref: this.storeAutocompleteRef
	        },
	        function (_ref) {
	          var getInputProps = _ref.getInputProps,
	              suggestions = _ref.suggestions,
	              getSuggestionItemProps = _ref.getSuggestionItemProps;
	          return _react2.default.createElement(
	            _styledComponents.LocationWrapper,
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_styledComponents.InputComponent, _extends({}, getInputProps({
	                placeholder: cityPlaceHolderText
	              }), {
	                validate: _FormValidations.isRequired,
	                required: required,
	                value: value,
	                innerRef: _this2.storeInputRef,
	                inputType: inputType,
	                defaultValue: defaultValue
	              }))
	            ),
	            suggestions.length > 0 && _react2.default.createElement(
	              _styledComponents.PlacesSuggestionContainer,
	              {
	                suggestionsContainerWidth: suggestionsContainerWidth
	              },
	              suggestions.map(function (suggestion) {
	                return _react2.default.createElement(
	                  _styledComponents.SuggestionContainer,
	                  _extends({}, getSuggestionItemProps(suggestion), {
	                    active: suggestion.active ? _bookNowFormConstants2.default.ACTIVE : _bookNowFormConstants2.default.INACTIVE
	                  }),
	                  _react2.default.createElement(
	                    _styledComponents.SuggestionInnerContainer,
	                    null,
	                    _react2.default.createElement(
	                      _styledComponents.SuggestionContainerMainText,
	                      null,
	                      suggestion.formattedSuggestion.mainText
	                    ),
	                    _react2.default.createElement(
	                      _styledComponents.SuggestionContainerSecondaryText,
	                      null,
	                      suggestion.formattedSuggestion.secondaryText
	                    )
	                  )
	                );
	              })
	            )
	          );
	        }
	      )
	    );
	  };
	
	  return LocationSearchInput;
	}(_react2.default.Component);
	
	LocationSearchInput.defaultProps = {
	  searchOptions: _googlePlacesConstants.SEARCH_OPTIONS,
	  handleChange: function handleChange() {}
	};
	exports.default = LocationSearchInput;
	module.exports = exports['default'];

/***/ }),

/***/ 1006:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ViuDownArrow = __webpack_require__(166);
	
	var _styledComponents = __webpack_require__(379);
	
	__webpack_require__(2250);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactSelectInput = function (_Component) {
	  _inherits(ReactSelectInput, _Component);
	
	  function ReactSelectInput(props) {
	    _classCallCheck(this, ReactSelectInput);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.arrowRenderer = function () {
	      return _react2.default.createElement(_ViuDownArrow.ViuDownArrow, null);
	    };
	
	    _this.logChange = function (value) {
	      var onChange = _this.props.onChange;
	
	      _this.setState({ displayError: false, errorMsg: 'Error', value: value }, function () {
	        return onChange(_this.state.value);
	      });
	    };
	
	    _this.setError = function (error) {
	      _this.setState({ errorMsg: error });
	    };
	
	    _this.setDisplayError = function (displayError) {
	      _this.setState({ displayError: displayError });
	    };
	
	    _this.validate = function () {
	      var validate = _this.props.validate;
	
	      var response = void 0;
	      if (validate) {
	        response = validate(_this.state.value);
	        if (response.displayError) {
	          _this.setError(response.errorMsg);
	        }
	        _this.setDisplayError(response.displayError);
	      }
	      return response;
	    };
	
	    _this.getFormValues = function (value, occupationDropDownWithStyle, style) {
	      var newOption = {
	        label: value,
	        value: value,
	        style: style
	      };
	      var isPresent = function isPresent(newValue) {
	        return occupationDropDownWithStyle.some(function (el) {
	          return el.label === newValue;
	        });
	      };
	      if (!isPresent(value) && value !== '') {
	        return occupationDropDownWithStyle.concat(newOption);
	      } else {
	        return occupationDropDownWithStyle;
	      }
	    };
	
	    _this.state = {
	      value: '',
	      errorMsg: 'Error',
	      displayError: false
	    };
	    return _this;
	  }
	
	  ReactSelectInput.prototype.render = function render() {
	    var style = {
	      fontFamily: 'din-2014',
	      fontSize: '14px',
	      fontWeight: 'normal',
	      fontStyle: 'normal'
	    };
	
	    var _state = this.state,
	        value = _state.value,
	        displayError = _state.displayError,
	        errorMsg = _state.errorMsg;
	    var _props = this.props,
	        placeholder = _props.placeholder,
	        className = _props.className,
	        occupationListDropDownValues = _props.occupationListDropDownValues;
	
	
	    var occupationDropDownWithStyle = occupationListDropDownValues.map(function (occupationObject) {
	      return _extends({}, occupationObject, {
	        style: style
	      });
	    });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_styledComponents.ReactSelect, {
	        options: this.getFormValues(value, occupationDropDownWithStyle, style),
	        clearable: false,
	        simpleValue: true,
	        value: this.state.value,
	        onChange: this.logChange,
	        placeholder: placeholder,
	        className: className,
	        arrowRenderer: this.arrowRenderer,
	        displayError: displayError
	      }),
	      _react2.default.createElement(
	        _styledComponents.ReactSelectError,
	        { displayError: displayError },
	        errorMsg
	      )
	    );
	  };
	
	  return ReactSelectInput;
	}(_react.Component);
	
	exports.default = ReactSelectInput;
	module.exports = exports['default'];

/***/ }),

/***/ 1007:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var dropDownFields = exports.dropDownFields = [{
	  label: 'Employee',
	  value: 'Employee'
	}, {
	  label: 'Business',
	  value: 'Business'
	}];
	
	var employeeFields = exports.employeeFields = [{
	  label: '<3L',
	  value: '<3L'
	}, {
	  label: '3 - 6L',
	  value: '3 - 6L'
	}, {
	  label: '6 - 12L',
	  value: '6 - 12L'
	}, {
	  label: '12 - 24L',
	  value: '12 - 24L'
	}, {
	  label: '24 - 36L',
	  value: '24 - 36L'
	}, {
	  label: '36 - 50L',
	  value: '36 - 50L'
	}, {
	  label: '50 - 1Cr',
	  value: '50 - 1Cr'
	}, {
	  label: ' > 1Cr',
	  value: ' > 1Cr'
	}];
	
	var businessFields = exports.businessFields = [{
	  label: '<10 lakhs',
	  value: '<10 lakhs'
	}, {
	  label: ' <1 crores',
	  value: ' <1 crores'
	}, {
	  label: '<5 crores',
	  value: '<5 crores'
	}, {
	  label: '>5 crores',
	  value: '>5 crores'
	}];
	
	var ageDropDownFields = exports.ageDropDownFields = [{
	  label: '18 to 24',
	  value: '18 to 24'
	}, {
	  label: '25 to 35',
	  value: '25 to 35'
	}, {
	  label: '36 to 50',
	  value: '36 to 50'
	}, {
	  label: '51 to 70',
	  value: '51 to 70'
	}, {
	  label: '>70',
	  value: '>70'
	}];
	
	var ClosedQuestionDropDownFields = exports.ClosedQuestionDropDownFields = [{
	  label: 'Yes',
	  value: 'Yes'
	}, {
	  label: 'No',
	  value: 'No'
	}];
	
	var WhichOpportunityAreYouInterestedInFields = exports.WhichOpportunityAreYouInterestedInFields = [{
	  label: 'Arcade Franchise',
	  value: 'Arcade Franchise'
	}, {
	  label: 'Area License',
	  value: 'Area License'
	}, {
	  label: 'Other',
	  value: 'Other'
	}];

/***/ }),

/***/ 1008:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _reactPlacesAutocomplete = __webpack_require__(63);
	
	var _FormValidations = __webpack_require__(42);
	
	var _googlePlacesUtils = __webpack_require__(224);
	
	var _navigationUtils = __webpack_require__(16);
	
	var _forms = __webpack_require__(44);
	
	var _ApplyForFranchiseConstants = __webpack_require__(1546);
	
	var _dropDownFields = __webpack_require__(1007);
	
	var _LocationSearchInput = __webpack_require__(1005);
	
	var _LocationSearchInput2 = _interopRequireDefault(_LocationSearchInput);
	
	__webpack_require__(2249);
	
	var _styledComponents = __webpack_require__(379);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * /
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               /** TODO: here we are getting error when gls is loaded here, so, we will debug that in v2 (tracker: https://tracker.apigateway.in/issues/2648) */
	
	var ApplyForFranchiseForm = function (_React$Component) {
	  _inherits(ApplyForFranchiseForm, _React$Component);
	
	  function ApplyForFranchiseForm(props) {
	    _classCallCheck(this, ApplyForFranchiseForm);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.clearTextInput = function () {
	      _this.emailRef.state.value = '';
	      _this.nameRef.state.value = '';
	      _this.phoneRef.state.value = '';
	      _this.occupationRef.state.value = '';
	      _this.placesInputRef.clearValues();
	      _this.cityOfResidenceRef.clearValues();
	      var form = document.getElementById('ApplyFranchiseForm');
	      form.reset();
	      _this.setState({
	        residenceState: '',
	        residenceCountry: '',
	        businessCountry: '',
	        businessState: ''
	      });
	    };
	
	    _this.storePlacesInputRef = function (ref) {
	      _this.placesInputRef = ref;
	    };
	
	    _this.storeEmailRef = function (ref) {
	      _this.emailRef = ref;
	    };
	
	    _this.storeNameRef = function (ref) {
	      _this.nameRef = ref;
	    };
	
	    _this.storeLastNameRef = function (ref) {
	      _this.lastNameRef = ref;
	    };
	
	    _this.storeAgeRef = function (ref) {
	      _this.ageRef = ref;
	    };
	
	    _this.storeHaveYouExperienceIBCricketRef = function (ref) {
	      _this.haveYouExperienceIBCricketRef = ref;
	    };
	
	    _this.storeWhichOpportunityAreYouIntrested = function (ref) {
	      _this.whichOpportunityAreYouIntrestedRef = ref;
	    };
	
	    _this.storeDoYouHaveSpaceAvailableForSetupRef = function (ref) {
	      _this.doYouHaveSpaceAvailableForSetupRef = ref;
	    };
	
	    _this.storePhoneRef = function (ref) {
	      _this.phoneRef = ref;
	    };
	
	    _this.storeCitiesInputRef = function (ref) {
	      _this.cityOfResidenceRef = ref;
	    };
	
	    _this.storeOccupationRef = function (ref) {
	      _this.occupationRef = ref;
	    };
	
	    _this.storeOccupationSpecificRef = function (ref) {
	      _this.occupationSpecificRef = ref;
	    };
	
	    _this.storeResidenceCountryRef = function (ref) {
	      _this.residenceCountryRef = ref;
	    };
	
	    _this.storeBusinessCountryRef = function (ref) {
	      _this.businessCountryRef = ref;
	    };
	
	    _this.storeWhyAreYouInterestedRef = function (ref) {
	      _this.whyAreYouInterestedRef = ref;
	    };
	
	    _this.validateAllFields = function () {
	      // CityFieldValidation
	      var cityValidationResponse = _this.placesInputRef.validate();
	      var isValidCityField = !cityValidationResponse.displayError;
	      // CityFieldValidation
	      var cityOfResidenceValidationResponse = _this.cityOfResidenceRef.validate();
	      var isValidCityOfResidenceField = !cityOfResidenceValidationResponse.displayError;
	      // EmailFieldValidation
	      var emailValidationResponse = _this.emailRef.validate();
	      var isValidEmailField = !emailValidationResponse.displayError;
	      // NameValidation
	      var nameValidationResponse = _this.nameRef.validate();
	      var isValidNameField = !nameValidationResponse.displayError;
	      // LastName validation
	      var lastNameValidationResponse = _this.lastNameRef.validate();
	      var isValidLastNameField = !lastNameValidationResponse.displayError;
	      // Age validation
	      var ageValidationResponse = _this.ageRef.validate();
	      var isValidAgeField = !ageValidationResponse.displayError;
	
	      // haveYouExperienceIBCricket validation
	      var haveYouExperienceIBCricketValidationResponse = _this.haveYouExperienceIBCricketRef.validate();
	      var isValidHaveYouExperienceIBCricketField = !haveYouExperienceIBCricketValidationResponse.displayError;
	
	      var whichOpportunityAreYouIntrestedResponse = _this.whichOpportunityAreYouIntrestedRef.validate();
	      var isValidWhichOpportunityAreYouIntrestedField = !whichOpportunityAreYouIntrestedResponse.displayError;
	
	      // doYouHaveAnySpaceReadilyAvailableToSetUpIBCricket validation
	      var doYouHaveSpaceAvailableForSetupValidationResponse = _this.doYouHaveSpaceAvailableForSetupRef.validate();
	      var isValiddoYouHaveSpaceAvailableForSetupField = !doYouHaveSpaceAvailableForSetupValidationResponse.displayError;
	
	      // Business validation
	      var isValidBusinessField = true;
	      if (_this.businessRef) {
	        var businessValidationResponse = _this.businessRef.validate();
	        isValidBusinessField = !businessValidationResponse.displayError;
	      }
	
	      // OccupationValidation
	      var isValidOccupationField = true;
	      if (_this.occupationRef) {
	        var occupationValidationResponse = _this.occupationRef.validate();
	        isValidOccupationField = !occupationValidationResponse.displayError;
	      }
	
	      var isValidOccupationSpecificField = true;
	      if (_this.occupationSpecificRef) {
	        isValidOccupationSpecificField = !_this.occupationSpecificRef.validate().displayError;
	      }
	
	      // PhoneValidation
	      var phoneValidationResponse = _this.phoneRef.validate();
	      var isValidPhoneField = !phoneValidationResponse.displayError;
	
	      // Country Validation
	
	      var isValidCountry = !_this.residenceCountryRef.validate().displayError;
	
	      var isValidBusinessCountry = !_this.businessCountryRef.validate().displayError;
	      var isValidWhyAreYouInterested = !_this.whyAreYouInterestedRef.validate().displayError;
	
	      return isValidCityField && isValidEmailField && isValidPhoneField && isValidNameField && isValidLastNameField && isValidAgeField && isValidHaveYouExperienceIBCricketField && isValidOccupationField && isValidOccupationSpecificField && isValidBusinessField && isValidCityOfResidenceField && isValidCountry && isValiddoYouHaveSpaceAvailableForSetupField && isValidBusinessCountry && isValidWhyAreYouInterested;
	    };
	
	    _this.goBack = function () {
	      _this.setState({ formMode: _ApplyForFranchiseConstants.formMode.indianDefault }, function () {
	        return history.replaceState('', '', (0, _gatsbyLink.withPrefix)('/franchise/'));
	      } //eslint-disable-line
	      );
	    };
	
	    _this.onFailureSubmitForm = function () {
	      // TODO: Need to ask for UI to design team: @dependency on Anesh,Design
	    };
	
	    _this.toCamelCase = function (name) {
	      return name.toLowerCase().split(' ').map(function (word) {
	        return word.charAt(0).toUpperCase() + word.slice(1);
	      }).join(' ');
	    };
	
	    _this.submitForm = function () {
	      var addressValues = _this.addressValues,
	          residenceAddressValues = _this.residenceAddressValues;
	
	      var name = _this.toCamelCase(_this.nameRef.state.value);
	
	      var formElement = document.getElementById('ApplyFranchiseForm');
	      var htmlFormData = new FormData(formElement);
	      var radioButtonGroupValue = htmlFormData.get('radio'); //eslint-disable-line
	      var salary = null;
	      var annualTurnover = null;
	      switch (_this.state.formMode) {
	        case _ApplyForFranchiseConstants.formMode.indianBusiness:
	        case _ApplyForFranchiseConstants.formMode.otherCountryBusiness:
	          annualTurnover = _this.occupationSpecificRef.state.value;
	          break;
	        case _ApplyForFranchiseConstants.formMode.indianEmployee:
	        case _ApplyForFranchiseConstants.formMode.otherCountryEmployee:
	          salary = _this.occupationSpecificRef.state.value;
	          break;
	        default:
	      }
	      var _this$state = _this.state,
	          residenceState = _this$state.residenceState,
	          businessState = _this$state.businessState,
	          businessCountry = _this$state.businessCountry;
	
	
	      var formData = {
	        First_Name: name,
	        Last_Name: _this.lastNameRef.state.value,
	        Age: _this.ageRef.state.value,
	        Have_you_experienced_iB_Cricket: _this.haveYouExperienceIBCricketRef.state.value,
	        Which_opportunity_are_you_interested_in: _this.whichOpportunityAreYouIntrestedRef.state.value,
	        Email_ID: _this.emailRef.state.value,
	        Mobile_Number: _this.phoneRef.state.value,
	        Occupation: _this.occupationRef.state.value,
	        Salary_per_annum: salary,
	        Annual_turnover: annualTurnover,
	
	        City_of_Residence: _this.cityOfResidenceRef.state.address,
	        State: residenceState,
	        Country: _this.residenceCountryRef.state.value,
	
	        Is_space_available_for_the_setup: _this.doYouHaveSpaceAvailableForSetupRef.state.value,
	
	        Address: JSON.stringify(residenceAddressValues),
	
	        // // Preferred Location to Setup a Franchise:
	        Preferred_City_Town: _this.placesInputRef.state.address,
	        Preferred_State: businessState,
	        Preferred_Country: businessCountry,
	
	        Preferred_Location_Address: JSON.stringify(addressValues),
	
	        // Other information
	        Any_previous_experience_in_Business: radioButtonGroupValue,
	        Why_are_you_interested_in_taking_up_business_with_iB_Cricket: _this.whyAreYouInterestedRef.state.value
	      };
	      var requestObject = {
	        submission_data: formData,
	        form_unique_code: 'iB_Cricket_Franchise_Opportunities'
	      };
	      (0, _forms.submitFormAPI)(requestObject, function () {}, _this.onFailureSubmitForm);
	      _this.onFormSubmitSuccess();
	    };
	
	    _this.submitFormData = function () {
	      var address = _this.placesInputRef.state.address;
	      var residenceAddress = _this.cityOfResidenceRef.state.address;
	
	      _this.address = address;
	      _this.city_of_residence_address = residenceAddress;
	
	      Promise.all([(0, _reactPlacesAutocomplete.geocodeByAddress)(address), (0, _reactPlacesAutocomplete.geocodeByAddress)(residenceAddress)]).then(function (_ref) {
	        var addressResutls = _ref[0],
	            residenceAddressResults = _ref[1];
	
	        var addressValues = addressResutls[0];
	        var residenceAddressValues = residenceAddressResults[0];
	        if (_this.addressValues !== 'undefined') {
	          _this.addressValues = addressValues;
	        }
	        if (_this.residenceAddressValues !== 'undefined') {
	          _this.residenceAddressValues = residenceAddressValues;
	        }
	        return Promise.all([(0, _reactPlacesAutocomplete.getLatLng)(addressValues), (0, _reactPlacesAutocomplete.getLatLng)(residenceAddressValues)]);
	      }).then(function (_ref2) {
	        var franchiseLatLng = _ref2[0],
	            residenceLatLng = _ref2[1];
	
	        _this.franchiseLatLng = JSON.stringify(franchiseLatLng);
	        _this.residenceLatLng = JSON.stringify(residenceLatLng);
	      }).catch(function (e) {
	        var PlacesServiceStatus = window.google.maps.places.PlacesServiceStatus;
	
	        switch (e) {
	          case PlacesServiceStatus.ZERO_RESULTS:
	            return;
	          case PlacesServiceStatus.OVER_QUERY_LIMIT:
	          case PlacesServiceStatus.REQUEST_DENIED:
	          case PlacesServiceStatus.INVALID_REQUEST:
	          case PlacesServiceStatus.UNKNOWN_ERROR:
	          default:
	            throw e;
	        }
	      }).then(function () {
	        _this.submitForm();
	      }).catch(function (e) {
	        return void 0;
	      });
	
	      return null;
	    };
	
	    _this.onFormSubmitSuccess = function () {
	      _this.clearTextInput();
	      _this.setState({
	        submissionStatus: true,
	        formMode: _ApplyForFranchiseConstants.formMode.submitted
	      }, function () {
	        history.replaceState('', '', (0, _gatsbyLink.withPrefix)('/business-opportunities/thankyou/')); //eslint-disable-line
	        (0, _navigationUtils.scrollToSection)('ApplyFranchiseFormThankYou');
	      });
	    };
	
	    _this.handleChange = function () {
	      // TO remove ThankYou message after user changes
	      _this.setState({
	        submissionStatus: false
	      });
	    };
	
	    _this.setResidenceCountryField = function (value) {
	      _this.residenceCountryRef.state.value = value;
	      _this.residenceCountryRef.state.displayError = false;
	      _this.residenceAddressValues = '';
	      _this.setState({ residenceCountry: value });
	      _this.handleCountryChange();
	    };
	
	    _this.setResidenceStateField = function (value) {
	      _this.setState({ residenceState: value });
	    };
	
	    _this.handleResidenceError = function () {
	      _this.residenceCountryRef.state.value = '';
	      _this.residenceAddressValues = 'undefined';
	      _this.setState({ residenceCountry: '', residenceState: '' });
	    };
	
	    _this.handleResidenceLocationCountryError = function (error) {
	      _this.residenceCountryRef.state.value = '';
	      _this.residenceAddressValues = 'undefined';
	      _this.setState({ residenceCountry: '' });
	    };
	
	    _this.handleResidenceCityBlur = function (address) {
	      _this.setState({
	        submissionStatus: false
	      });
	      (0, _reactPlacesAutocomplete.geocodeByAddress)(address).then(function (results) {
	        return (0, _googlePlacesUtils.getCountry)(results[0]);
	      }).then(_this.setResidenceCountryField).catch(function (error) {
	        return _this.handleResidenceLocationCountryError(error);
	      });
	      (0, _reactPlacesAutocomplete.geocodeByAddress)(address).then(function (results) {
	        return (0, _googlePlacesUtils.getState)(results[0]);
	      }).then(_this.setResidenceStateField).catch(function (error) {
	        return void 0;
	      });
	    };
	
	    _this.setBusinessCountryField = function (value) {
	      _this.businessCountryRef.state.displayError = false;
	      _this.businessCountryRef.state.value = value;
	      _this.addressValues = '';
	      _this.setState({ businessCountry: value });
	    };
	
	    _this.setBusinessStateField = function (value) {
	      _this.setState({ businessState: value });
	    };
	
	    _this.handleBusinessError = function () {
	      _this.businessCountryRef.state.value = '';
	      _this.setState({ businessCountry: '', businessState: '' });
	      _this.addressValues = 'undefined';
	    };
	
	    _this.handleBusinessLocationCountryError = function (error) {
	      _this.businessCountryRef.state.value = '';
	      _this.addressValues = 'undefined';
	      _this.setState({ businessCountry: '' });
	    };
	
	    _this.handleBusinessCityBlur = function (address) {
	      _this.setState({
	        submissionStatus: false
	      });
	      (0, _reactPlacesAutocomplete.geocodeByAddress)(address).then(function (results) {
	        return (0, _googlePlacesUtils.getCountry)(results[0]);
	      }).then(_this.setBusinessCountryField).catch(function (error) {
	        return _this.handleBusinessLocationCountryError(error);
	      });
	      (0, _reactPlacesAutocomplete.geocodeByAddress)(address).then(function (results) {
	        return (0, _googlePlacesUtils.getState)(results[0]);
	      }).then(_this.setBusinessStateField).catch(function (error) {
	        return void 0;
	      });
	    };
	
	    _this.handleOccupationChange = function (value) {
	      var isInIndianMode = function isInIndianMode() {
	        switch (_this.state.formMode) {
	          case _ApplyForFranchiseConstants.formMode.indianBusiness:
	          case _ApplyForFranchiseConstants.formMode.indianEmployee:
	          case _ApplyForFranchiseConstants.formMode.indianDefault:
	            return true;
	          case _ApplyForFranchiseConstants.formMode.default:
	          case _ApplyForFranchiseConstants.formMode.otherCountryBusiness:
	          case _ApplyForFranchiseConstants.formMode.otherCountryEmployee:
	            return false;
	          default:
	            throw Error('Apply Franchise Form shouldn\'t be in ' + _this.state.formMode);
	        }
	      };
	
	      var setValueByCountry = function setValueByCountry(indianValue, otherCountryValue) {
	        if (isInIndianMode()) {
	          _this.setState({ formMode: indianValue });
	        } else {
	          _this.setState({ formMode: otherCountryValue });
	        }
	      };
	
	      if (_ApplyForFranchiseConstants.BUSINESS.test(value) === true) {
	        setValueByCountry(_ApplyForFranchiseConstants.formMode.indianBusiness, _ApplyForFranchiseConstants.formMode.otherCountryBusiness);
	      } else if (_ApplyForFranchiseConstants.EMPLOYEE.test(value) === true) {
	        setValueByCountry(_ApplyForFranchiseConstants.formMode.indianEmployee, _ApplyForFranchiseConstants.formMode.otherCountryEmployee);
	      } else {
	        setValueByCountry(_ApplyForFranchiseConstants.formMode.indianDefault, _ApplyForFranchiseConstants.formMode.default);
	      }
	    };
	
	    _this.setFormOccupationModeState = function () {
	      if ((0, _googlePlacesUtils.isIndia)(_this.state.residenceCountry)) {
	        switch (_this.state.formMode) {
	          case _ApplyForFranchiseConstants.formMode.default:
	            _this.setState({ formMode: _ApplyForFranchiseConstants.formMode.indianDefault });
	            break;
	          case _ApplyForFranchiseConstants.formMode.otherCountryEmployee:
	            _this.setState({ formMode: _ApplyForFranchiseConstants.formMode.indianEmployee });
	            break;
	          case _ApplyForFranchiseConstants.formMode.otherCountryBusiness:
	            _this.setState({ formMode: _ApplyForFranchiseConstants.formMode.indianBusiness });
	            break;
	          case _ApplyForFranchiseConstants.formMode.indianEmployee:
	          case _ApplyForFranchiseConstants.formMode.indianBusiness:
	          case _ApplyForFranchiseConstants.formMode.indianDefault:
	          default:
	            break;
	        }
	      } else {
	        switch (_this.state.formMode) {
	          case _ApplyForFranchiseConstants.formMode.indianDefault:
	            _this.setState({ formMode: _ApplyForFranchiseConstants.formMode.default });
	            break;
	          case _ApplyForFranchiseConstants.formMode.indianEmployee:
	            _this.setState({ formMode: _ApplyForFranchiseConstants.formMode.otherCountryEmployee });
	            break;
	          case _ApplyForFranchiseConstants.formMode.indianBusiness:
	            _this.setState({ formMode: _ApplyForFranchiseConstants.formMode.otherCountryBusiness });
	            break;
	          case _ApplyForFranchiseConstants.formMode.default:
	          case _ApplyForFranchiseConstants.formMode.otherCountryEmployee:
	          case _ApplyForFranchiseConstants.formMode.otherCountryBusiness:
	          default:
	            break;
	        }
	      }
	      return null;
	    };
	
	    _this.handleCountryChange = function (e) {
	      if (e !== undefined) {
	        _this.setState({ residenceCountry: e.target.value }, function () {
	          return _this.setFormOccupationModeState();
	        });
	      } else {
	        _this.setFormOccupationModeState();
	      }
	    };
	
	    _this.handleBusinessCountryChange = function (e) {
	      _this.setState({ businessCountry: e.target.value });
	    };
	
	    _this.handleSubmitFn = function () {
	      // Do validation
	      var isValidForm = _this.validateAllFields();
	      if (isValidForm) {
	        _this.submitFormData();
	      }
	    };
	
	    _this.handleSubmit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      _this.handleSubmitFn();
	    };
	
	    _this.renderOccupationSpecificDropdown = function () {
	      var currentMode = _this.state.formMode;
	      var required = _this.props.required;
	
	      // TODO: Update props from netlify
	
	      switch (currentMode) {
	        case _ApplyForFranchiseConstants.formMode.indianDefault:
	        case _ApplyForFranchiseConstants.formMode.default:
	          return _react2.default.createElement(_styledComponents.EmptyInputComponent, null);
	        case _ApplyForFranchiseConstants.formMode.indianEmployee:
	          return _react2.default.createElement(_styledComponents.EmployeeeSelectInput, {
	            type: 'text',
	            placeholder: 'Salary per annum',
	            innerRef: _this.storeOccupationSpecificRef,
	            onChange: _this.handleChange,
	            occupationListDropDownValues: _dropDownFields.employeeFields,
	            required: required,
	            validate: _FormValidations.isRequired
	          });
	        case _ApplyForFranchiseConstants.formMode.otherCountryEmployee:
	          return _react2.default.createElement(_styledComponents.InputComponent, {
	            type: 'text',
	            placeholder: 'Salary per annum (In dollars)',
	            required: required,
	            validate: _FormValidations.isRequired,
	            innerRef: _this.storeOccupationSpecificRef,
	            onChange: _this.handleChange
	          });
	
	        case _ApplyForFranchiseConstants.formMode.indianBusiness:
	          return _react2.default.createElement(_styledComponents.BusinessSelectInput, {
	            type: 'text',
	            placeholder: 'Annual turnover',
	            innerRef: _this.storeOccupationSpecificRef,
	            onChange: _this.handleChange,
	            occupationListDropDownValues: _dropDownFields.businessFields,
	            required: required,
	            validate: _FormValidations.isRequired
	          });
	        case _ApplyForFranchiseConstants.formMode.otherCountryBusiness:
	          return _react2.default.createElement(_styledComponents.InputComponent, {
	            type: 'text',
	            placeholder: 'Annual turnover (In dollars)',
	            required: required,
	            validate: _FormValidations.isRequired,
	            innerRef: _this.storeOccupationSpecificRef,
	            onChange: _this.handleChange
	          });
	        default:
	          return _react2.default.createElement(_styledComponents.EmptyInputComponent, null);
	      }
	    };
	
	    _this.state = {
	      submissionStatus: false,
	      formMode: _ApplyForFranchiseConstants.formMode.indianDefault,
	      residenceState: '',
	      residenceCountry: '',
	      businessCountry: '',
	      businessState: ''
	    };
	    return _this;
	  }
	
	  ApplyForFranchiseForm.prototype.render = function render() {
	    var _state = this.state,
	        submissionStatus = _state.submissionStatus,
	        currentMode = _state.formMode,
	        residenceCountry = _state.residenceCountry,
	        businessCountry = _state.businessCountry;
	    var _props = this.props,
	        formData = _props.formData,
	        glsLoaded = _props.glsLoaded,
	        required = _props.required,
	        formHeading = _props.formHeading;
	    var _formData$0$node$fron = formData[0].node.frontmatter,
	        nameFieldPlaceholder = _formData$0$node$fron.nameFieldPlaceholder,
	        emailFieldPlaceholder = _formData$0$node$fron.emailFieldPlaceholder,
	        phoneNumberFieldPlaceholder = _formData$0$node$fron.phoneNumberFieldPlaceholder,
	        occupationFieldPlaceholder = _formData$0$node$fron.occupationFieldPlaceholder,
	        ctaButtonText = _formData$0$node$fron.ctaButtonText,
	        thankYouTextOne = _formData$0$node$fron.thankYouTextOne,
	        thankYouTextTwo = _formData$0$node$fron.thankYouTextTwo;
	
	    if (currentMode === _ApplyForFranchiseConstants.formMode.submitted) {
	      return _react2.default.createElement(
	        _styledComponents.ResponsiveContainer,
	        null,
	        _react2.default.createElement(
	          _styledComponents.SuccessContainer,
	          { id: 'ApplyFranchiseFormThankYou' },
	          _react2.default.createElement(
	            _styledComponents.SuccessText,
	            { submitted: submissionStatus },
	            _react2.default.createElement(_styledComponents.PrimaryThankYouText, {
	              dangerouslySetInnerHTML: {
	                __html: thankYouTextOne
	              }
	            }),
	            _react2.default.createElement(_styledComponents.SecondaryThankYouText, {
	              dangerouslySetInnerHTML: {
	                __html: thankYouTextTwo
	              }
	            })
	          ),
	          _react2.default.createElement(
	            _styledComponents.Button,
	            {
	              type: 'button',
	              onClick: this.goBack,
	              id: 'ownAFranchiseFormOkButton'
	            },
	            'OK'
	          )
	        )
	      );
	    }
	    return _react2.default.createElement(
	      _styledComponents.ApplyForFormSection,
	      null,
	      _react2.default.createElement(
	        _styledComponents.Heading,
	        { as: 'div' },
	        formHeading
	      ),
	      glsLoaded ? _react2.default.createElement(
	        _styledComponents.FormContainer,
	        { id: 'ApplyFranchiseForm', autocomplete: 'off' },
	        _react2.default.createElement(_styledComponents.InputComponent, {
	          type: 'text',
	          placeholder: nameFieldPlaceholder,
	          required: required,
	          validate: _FormValidations.isRequired,
	          innerRef: this.storeNameRef,
	          onChange: this.handleChange
	        }),
	        _react2.default.createElement(_styledComponents.InputComponent, {
	          type: 'text',
	          placeholder: 'Last Name',
	          required: required,
	          validate: _FormValidations.isRequired,
	          innerRef: this.storeLastNameRef,
	          onChange: this.handleChange
	        }),
	        _react2.default.createElement(_styledComponents.AgeSelectInput, {
	          type: 'text',
	          placeholder: 'Age',
	          required: required,
	          validate: _FormValidations.isRequired,
	          innerRef: this.storeAgeRef,
	          onChange: this.handleChange,
	          occupationListDropDownValues: _dropDownFields.ageDropDownFields
	        }),
	        _react2.default.createElement(_styledComponents.InputComponent, {
	          type: 'text',
	          placeholder: emailFieldPlaceholder,
	          required: required,
	          validate: _FormValidations.isValidEmailId,
	          innerRef: this.storeEmailRef,
	          onChange: this.handleChange
	        }),
	        _react2.default.createElement(_styledComponents.InputComponent, {
	          type: 'text',
	          placeholder: phoneNumberFieldPlaceholder,
	          required: required,
	          validate: _FormValidations.isValidInternationalPhoneNumber,
	          innerRef: this.storePhoneRef,
	          onChange: this.handleChange
	        }),
	        _react2.default.createElement(_LocationSearchInput2.default, {
	          submissionStatus: submissionStatus,
	          ref: this.storeCitiesInputRef,
	          cityPlaceHolderText: 'City of Residence',
	          handleChange: this.handleChange,
	          onBlur: this.handleResidenceCityBlur,
	          handleError: this.handleResidenceError,
	          glsLoaded: glsLoaded,
	          validate: _FormValidations.isRequired,
	          required: required,
	          suggestionsContainerWidth: '94%'
	        }),
	        _react2.default.createElement(_styledComponents.InputComponent, {
	          type: 'text',
	          placeholder: 'Country',
	          value: residenceCountry,
	          required: required,
	          validate: _FormValidations.isRequired,
	          innerRef: this.storeResidenceCountryRef,
	          onChange: this.handleCountryChange,
	          inputType: 'fullInput'
	        }),
	        _react2.default.createElement(_styledComponents.OccupationSelectInput, {
	          type: 'text',
	          placeholder: occupationFieldPlaceholder,
	          innerRef: this.storeOccupationRef,
	          onChange: this.handleOccupationChange,
	          occupationListDropDownValues: _dropDownFields.dropDownFields,
	          required: required,
	          validate: _FormValidations.isRequired
	        }),
	        this.renderOccupationSpecificDropdown(),
	        _react2.default.createElement(_styledComponents.HaveYouExperienceIBCricketInput, {
	          type: 'text',
	          placeholder: 'Have you experienced iB Cricket?',
	          required: required,
	          validate: _FormValidations.isRequired,
	          occupationListDropDownValues: _dropDownFields.ClosedQuestionDropDownFields,
	          innerRef: this.storeHaveYouExperienceIBCricketRef,
	          onChange: this.handleChange
	        }),
	        _react2.default.createElement(_styledComponents.WhichOpportunityAreYouInterestedInput, {
	          type: 'text',
	          placeholder: 'Which opportunity are you interested in?',
	          required: required,
	          validate: _FormValidations.isRequired,
	          occupationListDropDownValues: _dropDownFields.WhichOpportunityAreYouInterestedInFields,
	          innerRef: this.storeWhichOpportunityAreYouIntrested,
	          onChange: this.handleChange
	        }),
	        _react2.default.createElement(
	          _styledComponents.PreferredLocationHeading,
	          null,
	          'Preferred location to set up iB Cricket Franchise?'
	        ),
	        _react2.default.createElement(_LocationSearchInput2.default, {
	          submissionStatus: submissionStatus,
	          ref: this.storePlacesInputRef,
	          cityPlaceHolderText: 'City/Town',
	          handleChange: this.handleChange,
	          onBlur: this.handleBusinessCityBlur,
	          handleError: this.handleBusinessError,
	          glsLoaded: glsLoaded,
	          required: required,
	          suggestionsContainerWidth: '97%'
	        }),
	        _react2.default.createElement(_styledComponents.InputComponent, {
	          type: 'text',
	          placeholder: 'Country',
	          value: businessCountry,
	          required: required,
	          validate: _FormValidations.isRequired,
	          innerRef: this.storeBusinessCountryRef,
	          onChange: this.handleBusinessCountryChange
	        }),
	        _react2.default.createElement(_styledComponents.DoYouHaveSpaceAvailableForSetupField, {
	          type: 'text',
	          placeholder: 'Is space available for the setup?',
	          required: required,
	          validate: _FormValidations.isRequired,
	          occupationListDropDownValues: _dropDownFields.ClosedQuestionDropDownFields,
	          innerRef: this.storeDoYouHaveSpaceAvailableForSetupRef,
	          onChange: this.handleChange
	        }),
	        _react2.default.createElement(
	          _styledComponents.RadioButtonContainer,
	          null,
	          _react2.default.createElement(
	            _styledComponents.RadioButtonHeading,
	            null,
	            'Any previous experience in business?'
	          ),
	          _react2.default.createElement(
	            _styledComponents.RadioButtonsWrapper,
	            null,
	            _react2.default.createElement(
	              'label',
	              { className: 'radioButtonContainer' },
	              _react2.default.createElement(
	                _styledComponents.RadioButtonLabel,
	                null,
	                'Yes'
	              ),
	              _react2.default.createElement('input', {
	                id: 'YesRadioButton',
	                type: 'radio',
	                name: 'radio',
	                value: 'Yes',
	                onChange: this.handleChange
	              }),
	              _react2.default.createElement('span', { className: 'checkmark' })
	            ),
	            _react2.default.createElement(
	              'label',
	              { className: 'radioButtonContainer' },
	              _react2.default.createElement(
	                _styledComponents.RadioButtonLabel,
	                null,
	                'No'
	              ),
	              _react2.default.createElement('input', {
	                id: 'NoRadioButton',
	                type: 'radio',
	                name: 'radio',
	                value: 'No',
	                onChange: this.handleChange
	              }),
	              _react2.default.createElement('span', { className: 'checkmark' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _styledComponents.WhyAreYouInterestedHeading,
	          null,
	          'Why are you interested in taking up business with iB Cricket?'
	        ),
	        _react2.default.createElement(_styledComponents.TextAreaComponent, {
	          type: 'textarea',
	          placeholder: '',
	          required: required,
	          validate: _FormValidations.isRequired,
	          innerRef: this.storeWhyAreYouInterestedRef,
	          onChange: this.handleChange,
	          inputType: 'fullInput'
	        }),
	        _react2.default.createElement(
	          _styledComponents.ButtonWrapper,
	          null,
	          _react2.default.createElement(
	            _styledComponents.Button,
	            {
	              type: 'submit',
	              onClick: this.handleSubmit,
	              id: 'ownAFranchiseFormSubmitButton',
	              as: 'button'
	            },
	            ctaButtonText
	          )
	        )
	      ) : _react2.default.createElement(
	        _styledComponents.Loading,
	        null,
	        'Loading ... '
	      )
	    );
	  };
	
	  return ApplyForFranchiseForm;
	}(_react2.default.Component);
	
	ApplyForFranchiseForm.defaultProps = {
	  required: 'Error',
	  formHeading: 'Leave your details below and we will get in touch with you!'
	};
	exports.default = ApplyForFranchiseForm;
	module.exports = exports['default'];

/***/ }),

/***/ 2249:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 2250:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ResponsiveContainer = exports.RadioButtonLabel = exports.RadioButtonsWrapper = exports.WhyAreYouInterestedHeading = exports.PreferredLocationHeading = exports.RadioButtonHeading = exports.RadioButtonContainer = exports.ReactSelectError = exports.SelectOption = exports.ReactSelect = exports.BusinessSelectInput = exports.DoYouHaveSpaceAvailableForSetupField = exports.WhichOpportunityAreYouInterestedInput = exports.HaveYouExperienceIBCricketInput = exports.AgeSelectInput = exports.EmployeeeSelectInput = exports.OccupationSelectInput = exports.Loading = exports.SuggestionContainerSecondaryText = exports.SuggestionContainerMainText = exports.SuggestionInnerContainer = exports.SuggestionContainer = exports.PlacesSuggestionContainer = exports.LocationWrapper = exports.SecondaryThankYouText = exports.PrimaryThankYouText = exports.SuccessText = exports.SuccessContainer = exports.Button = exports.ButtonText = exports.ButtonWrapper = exports.LocationInputComponent = exports.RadioButtonComponent = exports.EmptyInputComponent = exports.TextAreaComponent = exports.InputComponent = exports.FormContainer = exports.Heading = exports.ApplyForFormSection = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _reactSelect = __webpack_require__(101);
	
	var _mixins = __webpack_require__(4);
	
	var _bookNowFormConstants = __webpack_require__(31);
	
	var _bookNowFormConstants2 = _interopRequireDefault(_bookNowFormConstants);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _Din = __webpack_require__(8);
	
	var _Input = __webpack_require__(1009);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _styledComponents = __webpack_require__(673);
	
	var _ReactSelectInput = __webpack_require__(1006);
	
	var _ReactSelectInput2 = _interopRequireDefault(_ReactSelectInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ApplyForFormSection = /*#__PURE__*/exports.ApplyForFormSection = (0, _reactEmotion2.default)('div', {
	  target: 'e1bgovtt0'
	})('width:auto;display:flex;flex-direction:column;', _mixins.notMobile, '{margin-left:auto;width:555px;margin-right:auto;}', _mixins.mobile, '{width:90%;margin-left:auto;margin-right:auto;}'); /**
	                                                                                                                                                                                                  * 
	                                                                                                                                                                                                  * @author: Vamsi Tallam
	                                                                                                                                                                                                  * */
	
	/* eslint-disable no-confusing-arrow */
	
	var Heading = /*#__PURE__*/exports.Heading = (0, _reactEmotion2.default)(_Din.Typo18PumpkinOrangeDI, {
	  target: 'e1bgovtt1'
	})('line-height:1.56;letter-spacing:0.3px;padding-bottom:1.25em;padding-top:2.5em;margin-left:8px;', _mixins.mobile, '{margin-left:0;}');
	
	var FormContainer = /*#__PURE__*/exports.FormContainer = (0, _reactEmotion2.default)('form', {
	  target: 'e1bgovtt2'
	})('display:flex;flex-wrap:wrap;position:relative;justify-content:center;', _mixins.mobile, '{flex-direction:column;flex-wrap:nowrap;min-height:460px;padding-bottom:120px;}', _mixins.tablet, '{padding-bottom:130px;}padding-bottom:80px;');
	var InputComponent = /*#__PURE__*/exports.InputComponent = (0, _reactEmotion2.default)(_Input2.default, {
	  target: 'e1bgovtt3'
	})('width:', function (props) {
	  return props.inputType ? '521px' : '253px';
	}, ';background-color:', _Colors2.default.black20, ';position:relative;margin-right:1.071em;', _mixins.mobile, '{margin-right:0em;width:100%;}');
	var TextAreaComponent = /*#__PURE__*/exports.TextAreaComponent = (0, _reactEmotion2.default)(_Input2.default, {
	  target: 'e1bgovtt4'
	})('width:', function (props) {
	  return props.inputType ? '521px' : '253px';
	}, ';background-color:', _Colors2.default.black20, ';height:80px;position:relative;margin-right:1.071em;', _mixins.mobile, '{margin-right:0em;width:100%;}');
	var EmptyInputComponent = /*#__PURE__*/exports.EmptyInputComponent = (0, _reactEmotion2.default)('div', {
	  target: 'e1bgovtt5'
	})('width:253px;visibility:hidden;margin-right:1.071em;');
	var RadioButtonComponent = /*#__PURE__*/exports.RadioButtonComponent = (0, _reactEmotion2.default)('input', {
	  target: 'e1bgovtt6'
	})('width:24px;height:24px;background:', _Colors2.default.whiteTwo80, ';');
	var LocationInputComponent = /*#__PURE__*/exports.LocationInputComponent = (0, _reactEmotion2.default)('input', {
	  target: 'e1bgovtt7'
	})('height:38px;background-color:', _Colors2.default.black20, ';margin-right:15px;', _mixins.mobile, '{margin-right:0px;width:100%;}');
	
	var ButtonWrapper = /*#__PURE__*/exports.ButtonWrapper = (0, _reactEmotion2.default)('div', {
	  target: 'e1bgovtt8'
	})('display:flex;justify-content:center;');
	
	var ButtonText = /*#__PURE__*/exports.ButtonText = (0, _reactEmotion2.default)(_Din.Typo13PumpkinOrangeDR, {
	  target: 'e1bgovtt9'
	})('height:2.769em;border:solid 1px ', _Colors2.default.pumpkinOrange, ';display:flex;align-items:center;justify-content:center;cursor:pointer;padding:10px 25px 9px 25px;:hover{color:', _Colors2.default.whiteTwo, ';background-color:', _Colors2.default.pumpkinOrange, ';}');
	var Button = /*#__PURE__*/exports.Button = (0, _reactEmotion2.default)(_Din.BaseDinBold, {
	  target: 'e1bgovtt10'
	})('border:none;background:none;outline:none;height:2.769em;border:solid 1px ', _Colors2.default.pumpkinOrange, ';font-size:14px;line-height:1.54;letter-spacing:0.2px;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0.769em 1.923em 0.769em 1.923em;line-height:normal;color:', _Colors2.default.white, ';background-color:', _Colors2.default.pumpkinOrange, ';', _mixins.mobile, '{justify-content:center;display:flex;}');
	
	var SuccessContainer = /*#__PURE__*/exports.SuccessContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1bgovtt11'
	})('display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:60vh;');
	
	var SuccessText = /*#__PURE__*/exports.SuccessText = (0, _reactEmotion2.default)('div', {
	  target: 'e1bgovtt12'
	})('opacity:0.8;margin-top:0.313em;margin-bottom:20px;text-align:center;display:flex;flex-direction:column;visibility:', function (props) {
	  return props.submitted ? 'visible' : 'hidden';
	}, ';', _mixins.mobile, '{width:90%;}');
	var PrimaryThankYouText = /*#__PURE__*/exports.PrimaryThankYouText = (0, _reactEmotion2.default)(_Din.Typo24PumpkinOrangeDI, {
	  target: 'e1bgovtt13'
	})('margin-bottom:20px;text-align:center;font-size:26px;', _mixins.mobile, '{font-size:22px;}');
	var SecondaryThankYouText = /*#__PURE__*/exports.SecondaryThankYouText = (0, _reactEmotion2.default)(_Din.Typo24WhiteTwoDI, {
	  target: 'e1bgovtt14'
	})('text-align:center;', _mixins.mobile, '{font-size:22px;}');
	
	var LocationWrapper = /*#__PURE__*/exports.LocationWrapper = (0, _reactEmotion2.default)('div', {
	  target: 'e1bgovtt15'
	})('position:relative;');
	
	/**
	    TODO: - need to get style guide(color naming) from upendra, as he asked to get this styles from maps.google.com
	    * */
	
	var PlacesSuggestionContainer = /*#__PURE__*/exports.PlacesSuggestionContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1bgovtt16'
	})('font-family:din-2014;position:absolute;background-color:', _Colors2.default.white, ';border-radius:0 0 2px 2px;box-shadow:0 2px 4px ', _Colors2.default.black20, ';font-size:15px;z-index:2;width:', function (props) {
	  return props.suggestionsContainerWidth;
	}, ';top:2.533em;', _mixins.mobile, '{width:100%;}');
	var SuggestionContainer = /*#__PURE__*/exports.SuggestionContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1bgovtt17'
	})('background-color:', function (props) {
	  return props.active === _bookNowFormConstants2.default.ACTIVE ? '' + _Colors2.default.black6 : null;
	}, ';');
	var SuggestionInnerContainer = /*#__PURE__*/exports.SuggestionInnerContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1bgovtt18'
	})('font-family:din-2014;color:#8c8c8c;font-size:12px;line-height:2em;min-height:2em;padding-top:0.5em;padding-bottom:0.583em;border-top:1px solid #e6e6e6;cursor:default;text-align:left;overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap;:hover{background-color:', _Colors2.default.black6, ';}:active{background-color:', _Colors2.default.black6, ';}:focus{background-color:', _Colors2.default.black6, ';}');
	var SuggestionContainerMainText = /*#__PURE__*/exports.SuggestionContainerMainText = (0, _reactEmotion2.default)('span', {
	  target: 'e1bgovtt19'
	})('font-family:din-2014;color:#000;font-weight:500;font-size:13px;padding-left:1.154em;padding-right:0.385em;');
	var SuggestionContainerSecondaryText = /*#__PURE__*/exports.SuggestionContainerSecondaryText = (0, _reactEmotion2.default)('span', {
	  target: 'e1bgovtt20'
	})('font-family:din-2014;color:#8c8c8c;font-size:12px;line-height:2em;');
	var Loading = /*#__PURE__*/exports.Loading = (0, _reactEmotion2.default)('span', {
	  target: 'e1bgovtt21'
	})('color:', _Colors2.default.white, ';');
	
	var OccupationSelectInput = /*#__PURE__*/exports.OccupationSelectInput = (0, _reactEmotion2.default)(_ReactSelectInput2.default, {
	  target: 'e1bgovtt22'
	})('width:', function (props) {
	  return props.inputType ? '521px' : '253px';
	}, ';background-color:', _Colors2.default.black20, ';position:relative;margin-right:1.071em;', _mixins.mobile, '{margin-right:0em;width:100%;}');
	var EmployeeeSelectInput = /*#__PURE__*/exports.EmployeeeSelectInput = (0, _reactEmotion2.default)(_ReactSelectInput2.default, {
	  target: 'e1bgovtt23'
	})('width:', function (props) {
	  return props.inputType ? '521px' : '253px';
	}, ';background-color:', _Colors2.default.black20, ';position:relative;margin-right:1.071em;', _mixins.mobile, '{margin-right:0em;width:100%;}');
	var AgeSelectInput = /*#__PURE__*/exports.AgeSelectInput = (0, _reactEmotion2.default)(_ReactSelectInput2.default, {
	  target: 'e1bgovtt24'
	})('width:', function (props) {
	  return props.inputType ? '521px' : '253px';
	}, ';background-color:', _Colors2.default.black20, ';position:relative;margin-right:1.071em;', _mixins.mobile, '{margin-right:0em;width:100%;}');
	var HaveYouExperienceIBCricketInput = /*#__PURE__*/exports.HaveYouExperienceIBCricketInput = (0, _reactEmotion2.default)(AgeSelectInput, {
	  target: 'e1bgovtt25'
	})('width:521px;');
	
	var WhichOpportunityAreYouInterestedInput = /*#__PURE__*/exports.WhichOpportunityAreYouInterestedInput = (0, _reactEmotion2.default)(AgeSelectInput, {
	  target: 'e1bgovtt26'
	})('width:521px;');
	
	var DoYouHaveSpaceAvailableForSetupField = /*#__PURE__*/exports.DoYouHaveSpaceAvailableForSetupField = (0, _reactEmotion2.default)(HaveYouExperienceIBCricketInput, {
	  target: 'e1bgovtt27'
	})();
	
	var BusinessSelectInput = /*#__PURE__*/exports.BusinessSelectInput = (0, _reactEmotion2.default)(_ReactSelectInput2.default, {
	  target: 'e1bgovtt28'
	})('width:', function (props) {
	  return props.inputType ? '521px' : '253px';
	}, ';background-color:', _Colors2.default.black20, ';position:relative;margin-right:1.071em;', _mixins.mobile, '{margin-right:0em;width:100%;}');
	
	var ReactSelect = /*#__PURE__*/exports.ReactSelect = (0, _reactEmotion2.default)(_reactSelect.Creatable, {
	  target: 'e1bgovtt29'
	})('border:', function (props) {
	  return props.displayError ? '1px solid ' + _Colors2.default.dullRed : '1px solid ' + _Colors2.default.whiteTwo30;
	}, ';');
	
	var SelectOption = /*#__PURE__*/exports.SelectOption = (0, _reactEmotion2.default)(SuggestionInnerContainer, {
	  target: 'e1bgovtt30'
	})();
	
	var ReactSelectError = /*#__PURE__*/exports.ReactSelectError = (0, _reactEmotion2.default)(_styledComponents.ErrorText, {
	  target: 'e1bgovtt31'
	})('visibility:', function (props) {
	  return props.displayError ? 'visible' : 'hidden';
	}, ';');
	var RadioButtonContainer = /*#__PURE__*/exports.RadioButtonContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1bgovtt32'
	})('display:flex;width:100%;margin-bottom:35px;margin-left:2%;flex-direction:column;justify-content:flex-start;', _mixins.mobile, '{justify-content:space-between;', ' align-items:flex-start;}');
	var RadioButtonHeading = /*#__PURE__*/exports.RadioButtonHeading = (0, _reactEmotion2.default)(_Din.Typo16WhiteTwo80DR, {
	  target: 'e1bgovtt33'
	})('letter-spacing:0.3px;padding-bottom:15px;', _mixins.mobile, '{padding-bottom:0px;}');
	
	var PreferredLocationHeading = /*#__PURE__*/exports.PreferredLocationHeading = (0, _reactEmotion2.default)(RadioButtonHeading, {
	  target: 'e1bgovtt34'
	})('margin-left:2%;width:100%;', _mixins.mobile, '{margin-bottom:20px;}');
	var WhyAreYouInterestedHeading = /*#__PURE__*/exports.WhyAreYouInterestedHeading = (0, _reactEmotion2.default)(RadioButtonHeading, {
	  target: 'e1bgovtt35'
	})('margin-left:2%;width:100%;', _mixins.mobile, '{margin-bottom:20px;}');
	
	var RadioButtonsWrapper = /*#__PURE__*/exports.RadioButtonsWrapper = (0, _reactEmotion2.default)('div', {
	  target: 'e1bgovtt36'
	})('display:flex;flex-direction:row;justify-content:space-between;width:35%;', _mixins.mobile, '{align-items:center;}');
	var RadioButtonLabel = /*#__PURE__*/exports.RadioButtonLabel = (0, _reactEmotion2.default)(_Din.Typo16WhiteTwo80DR, {
	  target: 'e1bgovtt37'
	})('letter-spacing:0.3px;', ' margin-left:35px;');
	
	var ResponsiveContainer = /*#__PURE__*/exports.ResponsiveContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1bgovtt38'
	})('width:1124px;margin-right:auto;margin-left:auto;@media (min-width:320px) and (max-width:425px){width:93.75%;}@media (min-width:426px) and (max-width:767px){width:90%;}@media (min-width:768px) and (max-width:1123px){width:90%;}@media (min-width:1124px) and (max-width:1250px){width:90%;}');

/***/ }),

/***/ 1009:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(673);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author: Vamsi Tallam
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * */
	
	/** *
	 * TODO: need to make a common component
	 */
	
	var Input = function (_Component) {
	  _inherits(Input, _Component);
	
	  function Input(props) {
	    _classCallCheck(this, Input);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.setError = function (error) {
	      _this.setState({ errorMsg: error });
	    };
	
	    _this.setDisplayError = function (displayError) {
	      _this.setState({ displayError: displayError });
	    };
	
	    _this.validate = function () {
	      var _this$props = _this.props,
	          validationEnabled = _this$props.validationEnabled,
	          validate = _this$props.validate;
	
	      var response = void 0;
	      if (validationEnabled) {
	        if (validate) {
	          response = validate(_this.state.value || '');
	          if (response.displayError) {
	            _this.setError(response.errorMsg);
	          }
	          _this.setDisplayError(response.displayError);
	        }
	      }
	      return response;
	    };
	
	    _this.onFocusInput = function () {
	      _this.setState({
	        isFocused: true,
	        displayError: false,
	        errorMsg: _this.props.required
	      });
	      var onFocus = _this.props.onFocus;
	
	      if (onFocus) {
	        onFocus();
	      }
	    };
	
	    _this.onBlurInput = function () {
	      _this.setState({
	        isFocused: false
	      });
	      _this.validate();
	      var onBlur = _this.props.onBlur;
	
	      if (onBlur) {
	        onBlur();
	      }
	    };
	
	    _this.onChangeInput = function (e) {
	      var value = e.target.value;
	
	      _this.setState({
	        value: value,
	        errorMsg: _this.props.required,
	        displayError: false
	      });
	    };
	
	    _this.state = {
	      value: props.defaultValue || '',
	      errorMsg: _this.props.required, // This is just a sample text which we won't be displaying, we will use for maintaing uniform height in all the states
	      displayError: false,
	      isFocused: false
	    };
	    return _this;
	  }
	
	  Input.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.value !== this.state.value && nextProps.value !== undefined && nextProps.value !== null) {
	      this.setState({ value: nextProps.value });
	    }
	  };
	
	  Input.prototype.render = function render() {
	    var _state = this.state,
	        errorMsg = _state.errorMsg,
	        displayError = _state.displayError,
	        isFocused = _state.isFocused,
	        value = _state.value;
	
	    var _props = this.props,
	        required = _props.required,
	        label = _props.label,
	        className = _props.className,
	        Icon = _props.icon,
	        isMobile = _props.isMobile,
	        other = _objectWithoutProperties(_props, ['required', 'label', 'className', 'icon', 'isMobile']);
	
	    return _react2.default.createElement(
	      _styledComponents.InputContainer,
	      other,
	      label && _react2.default.createElement(
	        _styledComponents.LabelText,
	        {
	          id: 'input_label',
	          displayError: displayError,
	          isMobile: isMobile
	        },
	        label
	      ),
	      _react2.default.createElement(
	        _styledComponents.MainContainer,
	        {
	          isMobile: isMobile,
	          isFocused: isFocused,
	          className: className,
	          value: value
	        },
	        _react2.default.createElement(_styledComponents.CustomInput, _extends({
	          isFocused: isFocused,
	          displayError: displayError,
	          onFocus: this.onFocusInput
	        }, other, {
	          onChange: this.onChangeInput,
	          value: value,
	          onBlur: this.onBlurInput
	        }))
	      ),
	      _react2.default.createElement(
	        _styledComponents.ErrorText,
	        { as: 'p', displayError: displayError },
	        errorMsg
	      )
	    );
	  };
	
	  return Input;
	}(_react.Component);
	
	Input.defaultProps = {
	  required: 'Error',
	  isMobile: false,
	  validationEnabled: true,
	  placeholder: '',
	  label: '',
	  className: '',
	  validate: function validate() {}
	};
	
	exports.default = Input;
	module.exports = exports['default'];

/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.InputContainer = exports.IconContainer = exports.LabelText = exports.ErrorText = exports.CustomInput = exports.MainContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _BaseInput = __webpack_require__(65);
	
	var _BaseInput2 = _interopRequireDefault(_BaseInput);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _Din = __webpack_require__(8);
	
	var _mixins = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainContainer = /*#__PURE__*/exports.MainContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1oi1unx0'
	})('width:253px;height:39px;display:flex;align-items:center;box-sizing:border-box;flex-direction:row;justify-content:center;'); /**
	                                                                                                                                 * 
	                                                                                                                                 * @author: Vamsi Tallam
	                                                                                                                                 * */
	
	/* eslint-disable no-confusing-arrow */
	
	var CustomInput = /*#__PURE__*/exports.CustomInput = (0, _reactEmotion2.default)(_BaseInput2.default, {
	  target: 'e1oi1unx1'
	})('background-color:', _Colors2.default.black20, ';width:100%;height:100%;border:solid 1px\n    ', function (props) {
	  return props.displayError ? _Colors2.default.dullRed : 'rgba(255, 255, 255, 0.3)';
	}, ';outline:none;font-family:din-2014;font-size:16px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:1.43;padding-left:1.071em;padding-right:1.071em;color:', _Colors2.default.whiteTwo80, ';overflow:hidden;text-overflow:ellipsis;white-space:nowrap;\':focus\':{border:none;outline:none;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}\':-moz-focusring\':{border:none;outline:none;border-color:', _Colors2.default.whiteTwo10, ';}::placeholder{color:', _Colors2.default.whiteTwo70, ';line-height:1.43;}:-ms-input-placeholder{color:', _Colors2.default.whiteTwo70, ';line-height:1.43;}::-ms-input-placeholder{color:', _Colors2.default.whiteTwo70, ';line-height:1.43;}::-moz-placeholder{color:', _Colors2.default.whiteTwo70, ';line-height:2.43;}');
	var ErrorText = /*#__PURE__*/exports.ErrorText = (0, _reactEmotion2.default)(_Din.Typo12CoralTwoDRI, {
	  target: 'e1oi1unx2'
	})('margin-top:5px;line-height:1.67;opacity:0.8;visibility:', function (props) {
	  return props.displayError ? 'visible' : 'hidden';
	}, ';', _mixins.mobile, '{margin:5px 0px 5px 0px;}');
	
	var LabelText = /*#__PURE__*/exports.LabelText = (0, _reactEmotion2.default)(_Din.Typo13DarkGreyBlueDR, {
	  target: 'e1oi1unx3'
	})('display:block;margin-bottom:3px;color:', function (props) {
	  return props.displayError ? _Colors2.default.dullRed : props.isMobile ? _Colors2.default.whiteTwo : undefined;
	}, ';');
	
	var IconContainer = /*#__PURE__*/exports.IconContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1oi1unx4'
	})('user-select:none;width:11px;height:100%;');
	var InputContainer = /*#__PURE__*/exports.InputContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1oi1unx5'
	})();

/***/ }),

/***/ 1010:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ApplyForFranchiseForm = __webpack_require__(1008);
	
	var _ApplyForFranchiseForm2 = _interopRequireDefault(_ApplyForFranchiseForm);
	
	var _styledComponents = __webpack_require__(1011);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author: Vamsi Tallam
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * */
	
	var ApplyFranchiseComponent = function (_Component) {
	  _inherits(ApplyFranchiseComponent, _Component);
	
	  function ApplyFranchiseComponent() {
	    _classCallCheck(this, ApplyFranchiseComponent);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ApplyFranchiseComponent.prototype.render = function render() {
	    return _react2.default.createElement(
	      _styledComponents.SectionContainer,
	      null,
	      _react2.default.createElement(
	        _styledComponents.HeaderSectionContainer,
	        null,
	        _react2.default.createElement(
	          _styledComponents.PageContentWrapper,
	          null,
	          _react2.default.createElement(
	            _styledComponents.PageHeading,
	            null,
	            'iB Cricket - A Great Business Opportunity'
	          ),
	          _react2.default.createElement(
	            _styledComponents.PageDescription,
	            null,
	            'Businesses and individuals can partner with iB Cricket for area rights or setting up an arcade franchise'
	          )
	        )
	      ),
	      _react2.default.createElement(_ApplyForFranchiseForm2.default, this.props)
	    );
	  };
	
	  return ApplyFranchiseComponent;
	}(_react.Component);
	
	exports.default = ApplyFranchiseComponent;
	module.exports = exports['default'];

/***/ }),

/***/ 1011:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.PageDescription = exports.PageHeading = exports.PageContentWrapper = exports.ResponsiveContainer = exports.HeaderSectionContainer = exports.SectionContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _mixins = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionContainer = /*#__PURE__*/exports.SectionContainer = (0, _reactEmotion2.default)('section', {
	  target: 'e1dutdxo0'
	})('background-color:', _Colors2.default.blackDefault, ';font-size:16px;', (0, _mixins.customDevice)(480, 767), '{font-size:16px;}'); /**
	                                                                                                                                       * 
	                                                                                                                                       * @author: Vamsi Tallam
	                                                                                                                                       * */
	
	var HeaderSectionContainer = /*#__PURE__*/exports.HeaderSectionContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1dutdxo1'
	})('min-height:250px;background-image:url(\'https://res.cloudinary.com/due4dmz2b/image/fetch/dpr_auto,w_auto,f_auto,q_auto/https://proyuga-media-assets.s3.ap-south-1.amazonaws.com/IbcFranchise/franchise-header-bg.png\');width:100%;background-size:cover;background-repeat:no-repeat;background-position:bottom;background-position-y:95%;');
	
	var ResponsiveContainer = /*#__PURE__*/exports.ResponsiveContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1dutdxo2'
	})('width:900px;margin:auto;display:flex;flex-direction:column;', _mixins.mobile, '{width:88.8%;margin:auto;}', _mixins.tablet, '{width:90%;margin:auto;}', (0, _mixins.customDevice)(1024, 1140), '{width:90%;margin:auto;}');
	
	var PageContentWrapper = /*#__PURE__*/exports.PageContentWrapper = (0, _reactEmotion2.default)(ResponsiveContainer, {
	  target: 'e1dutdxo3'
	})('display:flex;flex-direction:column;justify-content:center;align-items:center;padding-top:128px;padding-bottom:40px;', _mixins.mobile, '{padding-top:100px;}');
	
	var PageHeading = /*#__PURE__*/exports.PageHeading = (0, _reactEmotion2.default)('p', {
	  target: 'e1dutdxo4'
	})('margin:0px 0px 10px 0px;font-family:Nort;font-size:30px;font-weight:bold;font-style:italic;font-stretch:normal;line-height:1.3;letter-spacing:normal;text-align:center;color:', _Colors2.default.whiteTwo, ';text-align:center;', _mixins.mobile, '{font-size:24px;}');
	
	var PageDescription = /*#__PURE__*/exports.PageDescription = (0, _reactEmotion2.default)('p', {
	  target: 'e1dutdxo5'
	})('font-family:din-2014;font-size:16px;font-weight:normal;font-stretch:normal;font-style:normal;line-height:1.56;letter-spacing:normal;text-align:center;color:', _Colors2.default.whiteThreeTwo, ';');

/***/ }),

/***/ 1546:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var formMode = exports.formMode = {
	  default: 'DEFAULT',
	  indianDefault: 'INDIAN_DEFAULT',
	  indianEmployee: 'INDIAN_EMPLOYEE',
	  indianBusiness: 'INDIAN_BUSINESS',
	  otherCountryEmployee: 'OTHER_COUNTRY_EMPLOYEE',
	  otherCountryBusiness: 'OTHER_COUNTRY_BUSINESS'
	};
	
	var BUSINESS = exports.BUSINESS = /business/i;
	
	var EMPLOYEE = exports.EMPLOYEE = /employee/i;

/***/ }),

/***/ 1560:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.graphqlQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(24);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(25);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _ApplyFranchiseComponent = __webpack_require__(1010);
	
	var _ApplyFranchiseComponent2 = _interopRequireDefault(_ApplyFranchiseComponent);
	
	var _darkTheme = __webpack_require__(30);
	
	var _darkTheme2 = _interopRequireDefault(_darkTheme);
	
	var _bookNowFormConstants = __webpack_require__(31);
	
	var _bookNowFormConstants2 = _interopRequireDefault(_bookNowFormConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IbcFranchise = function (_Component) {
	  _inherits(IbcFranchise, _Component);
	
	  function IbcFranchise(props) {
	    _classCallCheck(this, IbcFranchise);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.initMap = function () {
	      _this.setState({
	        glsLoaded: true
	      });
	    };
	
	    _this.state = {
	      glsLoaded: false
	    };
	    return _this;
	  }
	
	  IbcFranchise.prototype.loadGooglePlacesScript = function loadGooglePlacesScript() {
	    try {
	      window.initMap = this.initMap;
	      var gmapScriptEl = document.createElement('script');
	      gmapScriptEl.src = _bookNowFormConstants2.default.GOOGLE_SCRIPT_URL;
	      document.querySelector('body').insertAdjacentElement('beforeend', gmapScriptEl);
	    } catch (error) {}
	  };
	
	  IbcFranchise.prototype.componentDidMount = function componentDidMount() {
	    if (!window.google) {
	      this.loadGooglePlacesScript();
	    }
	    if (window.google) {
	      this.initMap();
	    }
	  };
	
	  IbcFranchise.prototype.render = function render() {
	    var glsLoaded = this.state.glsLoaded;
	    var data = this.props.data;
	    var seoData = data.applyForFranchiseSEOData.edges,
	        formData = data.applyForFranchiseData.edges,
	        formDropDownList = data.formDropDownList.edges;
	    var occupationListDropDownValues = formDropDownList[0].node.frontmatter.occupationListDropDownValues;
	    var _props = this.props,
	        headerPropsData = _props.headerPropsData,
	        footerProps = _props.footerProps,
	        isBookNowSlotOpened = _props.isBookNowSlotOpened,
	        bookNowModalData = _props.bookNowModalData;
	    var _seoData$0$node$front = seoData[0].node.frontmatter,
	        title = _seoData$0$node$front.title,
	        metaDescription = _seoData$0$node$front.metaDescription,
	        ogTitle = _seoData$0$node$front.ogTitle,
	        ogWebsiteUrl = _seoData$0$node$front.ogWebsiteUrl,
	        ogImageUrl = _seoData$0$node$front.ogImageUrl,
	        ogDescription = _seoData$0$node$front.ogDescription,
	        ogType = _seoData$0$node$front.ogType,
	        ogSiteName = _seoData$0$node$front.ogSiteName,
	        twitterCard = _seoData$0$node$front.twitterCard,
	        twitterUrl = _seoData$0$node$front.twitterUrl,
	        twitterSite = _seoData$0$node$front.twitterSite,
	        twitterTitle = _seoData$0$node$front.twitterTitle,
	        twitterDescription = _seoData$0$node$front.twitterDescription,
	        twitterImage = _seoData$0$node$front.twitterImage;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          title
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: metaDescription }),
	        _react2.default.createElement('meta', { property: 'og:title', content: ogTitle }),
	        _react2.default.createElement('meta', { property: 'og:url', content: ogWebsiteUrl }),
	        _react2.default.createElement('meta', { property: 'og:image', content: ogImageUrl }),
	        _react2.default.createElement('meta', { property: 'og:description', content: ogDescription }),
	        _react2.default.createElement('meta', { property: 'og:type', content: ogType }),
	        _react2.default.createElement('meta', { property: 'og:site_name', content: ogSiteName }),
	        _react2.default.createElement('meta', { name: 'twitter:card', content: twitterCard }),
	        _react2.default.createElement('meta', { property: 'twitter:title', content: twitterTitle }),
	        _react2.default.createElement('meta', { name: 'twitter:url', content: twitterUrl }),
	        _react2.default.createElement('meta', { name: 'twitter:site', content: twitterSite }),
	        _react2.default.createElement('meta', { property: 'twitter:description', content: twitterDescription }),
	        _react2.default.createElement('meta', { name: 'twitter:image', content: twitterImage }),
	        _react2.default.createElement('meta', { name: 'robots', content: 'noindex' })
	      ),
	      _react2.default.createElement(_Header2.default, {
	        headerPropsData: headerPropsData,
	        isBookNowSlotOpened: isBookNowSlotOpened,
	        bookNowModalData: bookNowModalData,
	        isFranchisePage: true
	      }),
	      _react2.default.createElement(_ApplyFranchiseComponent2.default, {
	        formData: formData,
	        glsLoaded: glsLoaded,
	        occupationListDropDownValues: occupationListDropDownValues,
	        hideSubHeading: true
	      }),
	      _react2.default.createElement(_Footer2.default, _extends({}, footerProps, { theme: _darkTheme2.default.footerSection }))
	    );
	  };
	
	  return IbcFranchise;
	}(_react.Component);
	
	exports.default = IbcFranchise;
	
	// eslint-disable-next-line
	
	var graphqlQuery = exports.graphqlQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-franchise-index-js-95a6b5444b30e16a88f3.js